import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const VerticalAlignmentTop = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4994 2H2.5C2.22386 2 2 2.22386 2 2.5V13.4994V13.5C2 13.7761 2.22386 14 2.5 14C2.50847 14 2.51689 13.9998 2.52525 13.9994H13.4741C13.4825 13.9998 13.4909 14 13.4994 14C13.6387 14 13.7647 13.943 13.8554 13.8511C13.9448 13.7608 14 13.6365 14 13.4994C14 13.491 13.9998 13.4826 13.9994 13.4743V2.52508C13.9998 2.51677 14 2.50841 14 2.5C14 2.22386 13.7761 2 13.5 2H13.4994ZM3 12.9994V3H12.9994V12.9994H3ZM5 4.5C4.72386 4.5 4.5 4.72386 4.5 5C4.5 5.27614 4.72386 5.5 5 5.5H11C11.2761 5.5 11.5 5.27614 11.5 5C11.5 4.72386 11.2761 4.5 11 4.5H5ZM7.80861 6.53794C7.86669 6.51385 7.9303 6.5004 7.997 6.50001C7.998 6.5 7.999 6.5 8 6.5C8.001 6.5 8.002 6.5 8.003 6.50001C8.12996 6.50077 8.25669 6.54958 8.35355 6.64645L9.85355 8.14645C10.0488 8.34171 10.0488 8.65829 9.85355 8.85355C9.65829 9.04881 9.34171 9.04881 9.14645 8.85355L8.5 8.20711L8.5 11C8.5 11.2761 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.2761 7.5 11L7.5 8.20711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L7.64645 6.64645C7.69439 6.59851 7.74964 6.56234 7.80861 6.53794Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default VerticalAlignmentTop
